import { Component, OnInit } from '@angular/core';
import { StepType, RegistrationStepService, ErrorStateService, TermsAndConditionsType } from '@fgb/core';

@Component({
  selector: 'fgb-registration-terms-and-conditions',
  templateUrl: './registration-terms-and-conditions.component.html',
  styleUrls: ['./registration-terms-and-conditions.component.scss'],
})
export class RegistrationTermsAndConditionsComponent implements OnInit {
  termsAndConditionsType = TermsAndConditionsType;
  readonly stepType = StepType.TermsAndConditions;
  accepted: boolean = false;

  constructor(private registrationStepService: RegistrationStepService, public registrationStepQuery: ErrorStateService) {}

  ngOnInit() {}

  submitStep() {
    this.registrationStepService
      .submitRegistrationStepData(this.stepType, { Accepted: this.accepted, TermsAndConditions: null })
      .toPromise();
  }
}
